import { OnboardingFormActions } from '../../../enums'
import { AddLicenseAction } from '../../../types/actions'

export const addLicense = (companyIndex: number): AddLicenseAction => ({
  type: OnboardingFormActions.ADD_LICENSE,
  payload: {
    companyIndex
  }
})
